import { IGamePlaySounds } from './IGamePlaySounds'
import { playSound } from '../sound'
import { SOUND_KEYS } from '../../components/GamePlayComponents/constant'
import { store } from '../../store'
import { getTimeLimitInSeconds } from '../../store/selectors/ludoboardSelectors'

export class VoiceOverSoundsPlayer implements IGamePlaySounds {
  playStartSoundOfGame(): void {
    playSound(SOUND_KEYS.ZYADA_SCORE_BANAO)
  }

  playTotalTimeSoundOfGame(): void {
    const totalTimeInMinutes = getTimeLimitInSeconds(store.getState()) / 60
    switch (totalTimeInMinutes) {
      case 5:
        playSound(SOUND_KEYS.FIVE_MINUTES_KA_GAME)
        break
      case 7:
        playSound(SOUND_KEYS.SEVEN_MINUTES_KA_GAME)
        break
      case 8:
        playSound(SOUND_KEYS.EIGHT_MINUTES_KA_GAME)
        break
      case 10:
        playSound(SOUND_KEYS.TEN_MINUTES_KA_GAME)
        break
      default:
        // if (__DEV__) {
        //   playSound(SOUND_KEYS.FIVE_MINUTES_KA_GAME)
        // }
        break
    }
  }

  playExtra56Score(): void {
    playSound(SOUND_KEYS.EXTRA_SCORE_MILA)
  }

  playHalfTimeSound(): void {
    playSound(SOUND_KEYS.HALF_TIME_SAMAPT)
  }

  playLastOneMinutesSound(): void {
    playSound(SOUND_KEYS.AAKHIRI_1_MINUTE_BAKI)
  }

  playSkipSound(skipCount: number): void {
    if (skipCount === 1) {
      playSound(SOUND_KEYS.CHAAL_MISS_HO_GAI)
    } else if (skipCount === 2) {
      playSound(SOUND_KEYS.DOBARA_CHAAL_MISS)
    } else {
      playSound(SOUND_KEYS.TEESRI_CHAAL_MISS)
    }
  }

  playTokenToHomeSound(): void {
    playSound(SOUND_KEYS.TOKEN_GHAR_LE_JAAEN)
  }

  playZyadaScoreSound(): void {
    playSound(SOUND_KEYS.ZYADA_SCORE_BANAO)
  }

  playDusrePlayerKaTokenKaatSkteHai(): void {
    playSound(SOUND_KEYS.DUSRE_PLAYER_KA_TOKEN_KAAT_SKTE_HAI)
  }

  playTokenKoSafeSpotPrLeJaaSkteHai(): void {
    playSound(SOUND_KEYS.TOKEN_KO_SAFE_SPOT_PR_LE_JAA_SKTE_HAI)
  }

  playTokenKoGharLeJaaSkteHai(): void {
    playSound(SOUND_KEYS.TOKEN_KO_GHAR_LE_JAA_SKTE_HAI)
  }

}
